/**
 * plugins/grid.ts — Containers de grade (.tool-grid, .cards, .hierarchy)
 *
 * Ferramentas: adicionar item, limpar tudo.
 */

import { VtbPlugin, IVtbRegistry, SmartCtx, closestInside } from '../types';

export class GridPlugin implements VtbPlugin {
    readonly panelId = 'vtb-grid';
    readonly selectorHints = ['.tool-grid', '.cards', '.hierarchy', '[data-vtb-id="tool-grid"]', '[data-vtb-id="grid"]'];

    detect(target: HTMLElement, visualEditor: HTMLElement): SmartCtx | null {
        const el = closestInside(target, visualEditor, e => 
            e.classList.contains('tool-grid') || 
            e.classList.contains('cards') || 
            e.classList.contains('hierarchy') ||
            e.dataset.vtbId === 'tool-grid' ||
            e.dataset.vtbId === 'grid' ||
            e.dataset.vtbId === 'hierarchy'
        );
        if (!el) return null;
        return { type: this.panelId, label: 'Grid / Container', el };
    }

    activate(ctx: SmartCtx, registry: IVtbRegistry): void {
        const chip = registry.q('vtb-grid .vtb-chip');
        if (chip) chip.textContent = ctx.el.classList.contains('hierarchy') ? '🌳 Hierarquia' : '📦 Grid';
    }

    setup(registry: IVtbRegistry): void {
        registry.q('vtb-grid-add')?.addEventListener('click', () => this._addItem(registry));
    }

    private _addItem(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;

        const firstChild = ctx.el.firstElementChild;
        if (firstChild) {
            const clone = firstChild.cloneNode(true) as HTMLElement;
            ctx.el.appendChild(clone);
            registry.sync();
            registry.selectEl(clone);
        }
    }
}
